var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 515,
    viewBox: "0 0 515 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_276_3082)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 257.633,
    cy: 257.772,
    r: 106.619,
    transform: "rotate(-30 257.633 257.772)",
    fill: "#F69A4D",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.633,
    cy: 257.772,
    r: 106.419,
    transform: "rotate(-30 257.633 257.772)",
    stroke: "url(#paint0_linear_276_3082)",
    strokeWidth: 0.400405
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_276_3082",
    x: 0.796097,
    y: 0.934265,
    width: 513.673,
    height: 513.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75.1,
    result: "effect1_foregroundBlur_276_3082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_3082",
    x1: 251.024,
    y1: 151.69,
    x2: 262.901,
    y2: 367.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBg);
export default __webpack_public_path__ + "static/media/listBg.3879ed4807ffd50b1eb74a4d10035ac4.svg";
export { ForwardRef as ReactComponent };